import { render, staticRenderFns } from "./InventoryCtrl.vue?vue&type=template&id=534f8792&"
import script from "./InventoryCtrl.vue?vue&type=script&lang=js&"
export * from "./InventoryCtrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports